// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralFillStealthHover, neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

export const ReportMenuStyles = (config: DesignSystem) => ({
    reportMenuContainer: {
        width: "140px",
        height: "190px",
        padding: "4px 0 !important",
        "font-size": "14px",
        "letter-spacing": applyLocalizedProperty("-0.012em", "0", config.direction),
        background: neutralLayerCard,
        "border-radius": "8px",
        "box-shadow": "0px 0px 5.6px rgba(0, 0, 0, 0.11), 0px 6.4px 14.4px rgba(0, 0, 0, 0.13)",
        "overflow-y": "scroll",

        "& li": {
            padding: "8px 14px !important",
            color: neutralForegroundRest,

            "&:hover": {
                background: neutralFillStealthHover,
                cursor: "pointer"
            }
        },

        /* Hide Scrollbars */
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar ": {
            display: "none"
        },
        "&:-moz-any(#content,#appcontent) browser": {
            [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "-14px !important",
            "overflow-y": "scroll",
            "margin-bottom": "-14px !important",
            "overflow-x": "scroll"
        }
    },

    reportMenuPopover: {
        [applyLocalizedProperty("right", "left", config.direction)]: "0",
        top: "10px"
    }
});